import type { ReactNode } from 'react';

import { cn } from '@/utils/cn';

export type StatusTone = 'active' | 'inactive' | 'dnc';

interface StatusPillProps {
  status: StatusTone;
  children?: ReactNode;
  className?: string;
}

const DEFAULT_LABEL: Record<StatusTone, string> = {
  active: 'Active',
  inactive: 'Inactive',
  dnc: 'Do not contact',
};

export function StatusPill({ status, children, className }: StatusPillProps) {
  return (
    <span className={cn('ds-status-pill', status, className)}>
      <span className="dot" />
      {children ?? DEFAULT_LABEL[status]}
    </span>
  );
}
